import Layout from '@/layout'
export default [
    // 工作台-数据总览
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:one'],
        children: [
            {
                path: 'one',
                component: () => import('@/views/visual/workbench/workbench-one'),
                name: 'workbench-one',
                meta: { noCache: false, title: '数据总览', activeMenu: '/workbench/workbench-one' }
            }
        ]
    },
    // 数据查询
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:two'],
        children: [
            {
                path: 'two',
                component: () => import('@/views/visual/workbench/workbench-two'),
                name: 'workbench-two',
                meta: { noCache: false, title: '数据查询', activeMenu: '/workbench/workbench-two' }
            }
        ]
    },
    // 历史数据分析
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:historical-data'],
        children: [
            {
                path: 'historical-data',
                component: () => import('@/views/visual/workbench/historical-data'),
                name: 'historical-data',
                meta: { noCache: false, title: '历史数据分析', activeMenu: '/workbench/historical-data' }
            }
        ]
    },
    // 假日数据分析
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:holidays-data'],
        children: [
            {
                path: 'holidays-data',
                component: () => import('@/views/visual/workbench/holidays-data'),
                name: 'holidays-data',
                meta: { noCache: false, title: '假日数据分析', activeMenu: '/workbench/holidays-data' }
            }
        ]
    },
    // 时间段分析
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:timePeriod'],
        children: [
            {
                path: 'time-period-analysis',
                component: () => import('@/views/visual/workbench/time-period-analysis'),
                name: 'time-period-analysis',
                meta: { noCache: false, title: '时间段分析', activeMenu: '/workbench/time-period-analysis' }
            },
            {
                path: 'time-period',
                component: () => import('@/views/visual/workbench/time-period'),
                name: 'time-period',
                meta: { noCache: false, title: '时段客流分析', activeMenu: '/workbench/time-period' }
            }
        ]
    },
    // 人脸识别, 客户画像
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:portrait'],
        children: [
            {
                path: 'portrait',
                component: () => import('@/views/visual/workbench/workbench-portrait'),
                name: 'workbench-portrait',
                meta: { noCache: false, title: '客户画像', activeMenu: '/workbench/workbench-portrait' }
            }
        ]
    },
    // 车流量查询
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:carQuery'],
        children: [
            {
                path: 'car-data-query',
                component: () => import('@/views/visual/workbench/car-data-query'),
                name: 'car-data-query',
                meta: { noCache: false, title: '车流量查询', activeMenu: '/workbench/workbench-portrait' }
            }
        ]
    },
    // 数据导出
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:three'],
        children: [
            {
                path: 'three',
                component: () => import('@/views/visual/workbench/workbench-three'),
                name: 'workbench-three',
                meta: { noCache: false, title: '数据导出', activeMenu: '/workbench/workbench-three' }
            }
        ]
    },
    // 数据修正
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:updateData'],
        children: [
            {
                path: 'updateData',
                component: () => import('@/views/visual/workbench/update-data'),
                name: 'update-data',
                meta: { noCache: false, title: '数据修正', activeMenu: '/workbench/update-data' }
            }
        ]
    },
    // 出入口客流查询
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:four'],
        children: [
            {
                path: 'four',
                component: () => import('@/views/visual/workbench/workbench-four'),
                name: 'workbench-four',
                meta: { noCache: false, title: '出入口客流查询', activeMenu: '/workbench/workbench-four' }
            }
        ]
    },
    // 销售分析
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:salesData:list'],
        children: [
            {
                path: 'sales-analysis',
                component: () => import('@/views/visual/workbench/sales-analysis'),
                name: 'sales-analysis',
                meta: { noCache: false, title: '销售数据分析', activeMenu: '/workbench/sales-analysis' }
            }
        ]
    },
    // 操作指南
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:handbook'],
        children: [
            {
                path: 'handbook',
                component: () => import('@/views/visual/workbench/workbench-handbook'),
                name: 'workbench-handbook',
                meta: { noCache: false, title: '操作指南', activeMenu: '/workbench/workbench-handbook' }
            }
        ]
    },
    // 售后服务
    {
        path: '/visual/workbench-item',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:aftersale'],
        children: [
            {
                path: 'aftersale',
                component: () => import('@/views/visual/workbench/workbench-aftersale'),
                name: 'workbench-aftersale',
                meta: { noCache: false, title: '售后服务', activeMenu: '/workbench/workbench-aftersale' }
            }
        ]
    },
    // 地图页面
    {
        path: '/visual/smart-toilet',
        component: Layout,
        hidden: true,
        permissions: ['kl:visual:entityMap'],
        children: [
            {
                path: 'map-entity',
                component: () => import('@/views/visual/smart-toilet/map-entity'),
                name: 'smart-toilet-map-entity',
                meta: { noCache: false, title: '实体地图可视化', activeMenu: '/workbench/workbench-aftersale' }
            }
        ]
    },
    {
        path: '/work',
        component: Layout,
        hidden: true,
        permissions: [],
        children: [
            {
                path: 'app-purchase-info',
                component: () => import('@/views/work/appMarket/app-purchase-info.vue'),
                name: 'app-purchase-info',
                meta: { noCache: false, title: '应用订购', activeMenu: '/app-market' }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        hidden: true,
        permissions: [],
        children: [
            {
                path: 'deivceInfo',
                component: () => import('@/views/kl/device/deivce-info.vue'),
                name: 'deivce-info',
                meta: { noCache: false, title: '企业设备详情', activeMenu: '/deivce' }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        hidden: true,
        permissions: [],
        children: [
            {
                path: 'entity-list',
                component: () => import('@/views/kl/entity/entity-list.vue'),
                name: 'entity-list',
                meta: { noCache: false, title: '实体列表', activeMenu: '/entity' }
            }
        ]
    },
    {
        path: '/',
        component: Layout,
        hidden: true,
        permissions: [],
        children: [
            {
                path: 'entity-map-mark',
                component: () => import('@/views/kl/entity/entity-map-mark.vue'),
                name: 'entity-map-mark',
                meta: { noCache: false, title: '实体地图标注', activeMenu: '/entity' }
            }
        ]
    }
]